export default "__VITE_ASSET__4YDla4fk__"